import { contract } from '@aviv_price-pages/brand';
export const DEFAULT_LOCALE = contract.i18n.defaultLocale;
/**
 * Map
 */
export const MAP_MIN_ZOOM = 4;
export const MAP_MAX_ZOOM = 22;
export const COLORS_SCALE_WIDTH = 146;
// Lock the zoom for interaction
// Must be lower than MAP_MAX_ZOOM to display layers at max zoom
export const MAP_MIN_ZOOM_INTERACTION = 4;
export const MAP_MAX_ZOOM_INTERACTION = 18;
export const MAP_TILE_ERROR_DURATION_DISPLAY = 10000;
export const MAP_DEFAULT_STYLE = 'mapbox://styles/meilleursagents/cm3wvpc19008g01quanu14e6h';
/**
 * Autocomplete
 */
export const DEFAULT_AUTOCOMPLETE_MAX_ITEMS = 5;
export const DEFAULT_AUTOCOMPLETE_LOADING_TIMEOUT_MS = 200;
export const BRAND_ID = contract.nameAbbreviation;
const portals = {
    imn: 'immonet.de',
    iwb: 'immoweb.be',
    iwt: 'immowelt.de',
    li: 'logic-immo.com',
};
export const PORTAL = portals[BRAND_ID];
